import { Controller } from "@hotwired/stimulus"

// Lädt weitere Interaktionen in der Bewerber-Seitenleiste erst beim Öffnen von <details> (ergänzt den Profil-Tab).
export default class extends Controller {
  static values = { url: String }
  static targets = ["frame"]

  toggle() {
    if (!this.element.open) return
    const f = this.frameTarget
    if (f && !f.src) {
      f.src = this.urlValue
    }
  }
}
